"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenAuthProvider = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const helpers_1 = require("./helpers");
const react_native_2 = require("react-native");
const initialTokenAuthState = {
    aggreementIsSigned: false,
    isSignout: true,
    baseURL: '',
    setIsSignout: () => { },
    handleSuccessfulLogin: () => { },
};
const TokenAuthContext = react_1.createContext(initialTokenAuthState);
const TokenAuthProvider = ({ baseURL, children }) => {
    const [isSignout, setIsSignout] = react_1.useState(true);
    const [initialLoading, setInitialLoading] = react_1.useState(true);
    const [aggreementIsSigned, setAggreementIsSigned] = react_1.useState(false);
    const handleSuccessfulLogin = async () => {
        const username = await helpers_1.getUsername();
        const aggreementIsSigned = await async_storage_1.default.getItem(`${username}-Agreement`);
        if (aggreementIsSigned !== null) {
            setAggreementIsSigned(true);
            setIsSignout(false);
        }
        else {
            setAggreementIsSigned(false);
            setIsSignout(false);
        }
    };
    react_1.useEffect(() => {
        (async () => {
            setInitialLoading(true);
            let authentication = await async_storage_1.default.getItem('sessionToken');
            if (authentication !== null) {
                await handleSuccessfulLogin();
            }
            setInitialLoading(false);
        })();
    }, []);
    return (react_1.default.createElement(TokenAuthContext.Provider, { value: {
            aggreementIsSigned,
            isSignout,
            baseURL,
            setIsSignout,
            handleSuccessfulLogin,
        } }, initialLoading ? (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(react_native_1.ActivityIndicator, { size: "large" }))) : (children)));
};
exports.TokenAuthProvider = TokenAuthProvider;
exports.default = TokenAuthContext;
const styles = react_native_2.StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});
